export enum Colors {
    TA_GREEN = "#A4FFCA",
    TA_WHITE = "#fff",
    TA_BLACK = "#000",
    TA_GREY = "#6F767E",
    TA_GREY_2 = "#3B5266",
    TA_ORANGE = "#FF5D09"
}
